import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Meta (Facebook) Pixel route tracker.
 * Fires `PageView` on every client-side navigation.
 * Safe against ad-blockers (checks window.fbq exists).
 */
export const MetaPixelTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname]);

  return null;
};
